import { render, staticRenderFns } from "./ManageDocument.vue?vue&type=template&id=397acb3d&"
import script from "./ManageDocument.vue?vue&type=script&lang=js&"
export * from "./ManageDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397acb3d')) {
      api.createRecord('397acb3d', component.options)
    } else {
      api.reload('397acb3d', component.options)
    }
    module.hot.accept("./ManageDocument.vue?vue&type=template&id=397acb3d&", function () {
      api.rerender('397acb3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/ManageDocument.vue"
export default component.exports